import Search from "./search.page";

export default Search;
